import { Control } from '@/gen/inventory/v1/control_service_pb'

import { groupControlsByCategory } from '@/pages/past-assessment/utils'

import type { ControlRow } from './types'
import { groupControlsByScope } from './utils/group-controls-by-scope'

export type GroupingStrategy = {
  groupFn: (controls: Control[], expandedGroups: Set<string>) => ControlRow[]
  checkboxLabel: string
  enableGroupCounting?: boolean
}

export const SCOPE_GROUPING: GroupingStrategy = {
  groupFn: groupControlsByScope,
  checkboxLabel: 'Group by scope',
  enableGroupCounting: true,
}

export const CATEGORY_GROUPING: GroupingStrategy = {
  groupFn: groupControlsByCategory,
  checkboxLabel: 'Group by category',
}
